import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function getJobsSummary() {
  const response = await fetch(`${apiEndpoint}/jobs/summary`, {
    method: 'GET',
    headers: await standardHeaders(),
    mode: 'cors',
  });
  if (response.ok) {
    return await response.json();
  }
  return [];
}
